"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BupaThemeContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultBrandContext = require("../../defaults/defaultBrandContext");
var _contactStatement = require("../../defaults/contactStatement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable max-len */
var linkFormat = function linkFormat(config, customProp) {
  if (config !== null && config !== void 0 && config.link) {
    return /*#__PURE__*/_react["default"].createElement("a", _extends({
      target: "_blank",
      rel: "noreferrer",
      href: config.link
    }, customProp), config.label);
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, config === null || config === void 0 ? void 0 : config.label);
};
var BupaThemeContext = exports.BupaThemeContext = _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
  brand: {
    key: 'bupa',
    title: 'Bupa',
    fullName: 'Bupa',
    shortName: 'Bupa',
    homeUrl: 'https://www.bupa.com.au',
    logos: [{
      key: 'bupaSmall',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/bupa/bupalogo.png',
      redirectUrl: 'https://www.bupa.com.au/pet-insurance'
    }],
    products: 'bupa',
    styleSheet: 'bupa',
    supportPhoneNumber: '1300 709 535',
    supportEmailAddress: 'bupa@petsure.com.au',
    partner: 'BUPA',
    marketingPartner: 'BUPA',
    broker: 'BUPA',
    favIconUrl: 'https://www.bupa.com.au/-/media/Dotcom/favicon.ico',
    certificateIssuer: 'sectigo',
    certificateIssuerUrl: 'https://sectigo.com',
    gtmId: '5FTQSCP',
    gtmDataLayer: 'dataLayer',
    actionButtonsBars: _objectSpread({}, _defaultBrandContext.DefaultBrandContext.brand.actionButtonsBars)
  },
  seo: {
    title: 'Bupa Pet Insurance',
    description: 'Explore our range of pet insurances and comprehensive policies all types of pets. Get in touch with us today.'
  },
  tracking: [{
    provider: 'GoogleAnalytics',
    key: 'gtmKey',
    keyValue: 'GTM-5FTQSCP'
  }],
  layout: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "phone"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1300556721"
      }, "Call us on ", /*#__PURE__*/_react["default"].createElement("strong", null, "1300 556 721")), /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.bupa.com.au/call-me-back/general-insurance"
      }, "Request a callback")))
    }),
    main: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.main), {}, {
      heading: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.main.heading), {}, {
        headingText: '',
        showMandatoryText: true
      })
    }),
    footer: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.footer), {}, {
      footerSections: null,
      socialLinks: null,
      copyright: null,
      customDisclosure: {
        brand: {
          label: 'Bupa'
        },
        tmd: {
          link: 'https://bupa.com.au/pet-insurance',
          label: 'bupa.com.au/pet-insurance'
        },
        vetChatTAndC: {
          link: 'https://bupa.vetchat.com.au/terms-and-conditions',
          label: 'bupa.vetchat.com.au/terms-and-conditions'
        },
        vetChatSignUp: {
          link: 'https://bupa.vetchat.com.au/signup',
          label: 'bupa.vetchat.com.au/signup'
        },
        authorisedRepresentative: 'PetSure’s Authorised Representative (AR) Bupa HI Pty Limited ABN 81 000 057 590, AR 354269',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by PetSure\u2019s Authorised Representative (AR) Bupa HI Pty Limited ABN 81 000 057 590, AR 354269. Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the Product Disclosure Statement (PDS) to ensure this product meets your needs before purchasing. PDS and Target Market Determination available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        hasExtraVetChatDescription: true,
        hasGapOnly: true,
        myPetPass: {
          hasMyPetPass: true,
          eligibilityWordings: 'Available only to holders of active Bupa Pet Insurance policies',
          superscriptOverride: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("sup", null, "2"), " myPetPass\u2122 is a rewards programme provided by PetSure (Australia) Pty Ltd ABN 95 075 949 923 (PetSure). Available only to holders of active Bupa Pet Insurance policies. myPetPass\u2122 perks are provided by PetSure and third-party suppliers and also subject to these third-party suppliers\u2019 terms and conditions. myPetPass\u2122 perks may be amended or withdrawn any time without notice. PetSure does not guarantee that any particular third-party providers will continue to participate in myPetPass\u2122 through the offer or provision of perks, or that the myPetPass\u2122 rewards programme or any myPetPass\u2122 perks or features of myPetPass\u2122 will continue to be available. Full Terms & Conditions available at ", linkFormat({
            label: 'mypetpass.com.au/terms',
            link: 'https://mypetpass.com.au/terms'
          }), "."), /*#__PURE__*/_react["default"].createElement("p", null, "^ Live Vet Support is a service provided by PetSure that gives you 24/7 access to general veterinary telehealth advice for your insured pet(s) via online video or chat, via the Customer Portals owned and operated by PetSure. Access to Live Vet Support consultations subject to the Customer Portal ", linkFormat({
            label: 'terms of use',
            link: 'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf'
          }), "."), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("sup", null, "#"), " 30% discount off the lowest online displayed price (excluding any items marked \u2018on sale\u2019 or \u2018on clearance\u2019) listed on\xA0", /*#__PURE__*/_react["default"].createElement("a", {
            href: "https://petscripts.com.au",
            target: "_blank",
            rel: "noreferrer"
          }, "petscripts.com.au"), "\xA0off your pet prescription medication purchased from PetScripts Pty Ltd ABN 73 610 444 427 (PetScripts), which is a related company of PetSure. Delivery fees may apply. The 30% discount is exclusive to you and only available to be used for the pet insured on your PetSure-administered policy. This 30% discount cannot be used in conjunction with any other offer or discount and is subject to PetScripts\u2019 general terms and conditions and their privacy policy available at\xA0", /*#__PURE__*/_react["default"].createElement("a", {
            href: "https://petscripts.com.au",
            target: "_blank",
            rel: "noreferrer"
          }, "petscripts.com.au"), ". \xA0Offer available until 31 December 2025 unless modified, limited or withdrawn before."))
        }
      }
    }),
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement("div", {
        key: "bupaContactCampaign",
        className: "bupaContact"
      }, "Call us on ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "tel://1300556721"
      }, "1300 556 721"), "\xA0", /*#__PURE__*/_react["default"].createElement("p", null, "between 8:00am and 6:30pm (AEST) Monday to Friday (except public holidays)")), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "bupaCampaign1",
        customCssClass: "bupaCampaign1",
        campaignImageDescription: "Campaign tile",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/bupa/Bupa_promo_tile.png"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "bupaCampaign2",
        customCssClass: "bupaCampaign2",
        campaignImageDescription: "myPetPass logo",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/bupa/Bupa_MyPetPass_QT_tile_464x400.png",
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "bupaCampaign3",
        customCssClass: "bupaCampaign4",
        campaignImageDescription: "GapOnly logo",
        campaignBaseUrl: "https://petcdnstore.blob.core.windows.net/qt-assets",
        campaignImageUrl: function campaignImageUrl(campaignBaseUrl) {
          return "".concat(campaignBaseUrl, "/Common/GapOnly_tile_232x200.png");
        },
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement("a", {
        key: "bupaPDS",
        className: "bupaPDS",
        target: "_blank",
        href: "https://www.bupa.com.au/-/media/Dotcom/Files/pdfs/pet-insurance-pds.pdf",
        rel: "noreferrer"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Click here to view the PDS"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "file-text"
      }))]
    }
  })
});
BupaThemeContext.contactStatement = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandContactStatement)(contactStatementLogoUrl, BupaThemeContext.brand.fullName, BupaThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Continue to cover options', BupaThemeContext.brand.shortName);
};
BupaThemeContext.privacyCollectionNotice = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandPrivacyCollectionNotice)(contactStatementLogoUrl, BupaThemeContext.brand.fullName, BupaThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Continue to summary', BupaThemeContext.brand.supportEmailAddress, BupaThemeContext.brand.shortName);
};
var _default = exports["default"] = {
  BupaThemeContext: BupaThemeContext
};